import { render, staticRenderFns } from "./CommonContest.vue?vue&type=template&id=90b42c1e&scoped=true&"
import script from "./CommonContest.vue?vue&type=script&lang=js&"
export * from "./CommonContest.vue?vue&type=script&lang=js&"
import style0 from "./CommonContest.vue?vue&type=style&index=0&id=90b42c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b42c1e",
  null
  
)

export default component.exports